import React from "react";
import { StyleSheet, View } from "react-native";
import getOnlyTwoDominateColors from "./../../common/helpers/onlyTwoDominateColors";
import DominateColor from "../../common/DominateColor";
import windowWidth from "../../common/windowWidth";
import { whiteColor } from "../../common/colors";

const BlockColors = (props) => {
  const onlyTwoDominateColors = getOnlyTwoDominateColors(props.result);

  return (
    <View style={styles.wrapper}>
      <View style={styles.colorsContainer}>
        {onlyTwoDominateColors.map((dominate, i) => (
          <DominateColor key={`dominate-${i}`} dominate={dominate} i={i} style={styles.block} />
        ))}
      </View>
    </View>
  );
};

export default BlockColors;

const styles = StyleSheet.create({
  wrapper: {
    justifyContent: "center",
    alignContent: "center",
  },
  colorsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "baseline",
    alignContent: "center",
  },
  block: {
    alignItems: "center",
    alignContent: "center",
    width: windowWidth() < 375 ? 130 : 158,
    backgroundColor: whiteColor,
    borderRadius: 3,
    paddingTop: 8,
    paddingBottom: 20,
    margin: 12,
    borderWidth: 0.5,
  },
});
